// extracted by mini-css-extract-plugin
export default {"moves":"Moves_moves__Q1oDh"};